import { IAuthState } from "@/core/interfaces/authState.interface";

const authState: IAuthState = {
  user: null,
  token: {
    access: "",
    refresh: "",
  },
  permissions: [],

  organization: undefined,
  financialProfiles: undefined,
  sectors: undefined,

  isUserSignedIn: false,
  isAuthenticating: false,
  isForgettingPassword: false,
  isResettingPassword: false,
  twoFactorToken: null,
  twoFactorQrCode: null,
  isTwoFactorLoginRequired: false,
};

export default authState;
